<template>
    <div class="list-dropdown">
        <input type="checkbox" class="list-dropdown__trigger" id="metroDropdown" :checked="isOpen" @click="toggle" >
        <div class="list-dropdown__wrapper">
            <label class="list-dropdown__title" for="metroDropdown">
                <span class="title">Метро</span>
                <span class="count" v-if="metroSelected && metroSelected.length > 0">{{metroSelected.length}}</span>               
            </label>
            <div class="list-dropdown__container" v-if="isOpen">
                <div class="list-dropdown__content">
                    <div class="list-dropdown__search">
                        <label class="input-container">
                            <input type="text" placeholder="Поиск" v-model="metroSearch">
                        </label>
                    </div>
                    <div class="list-dropdown__scroll">
                        <div role="alert" v-if="metroFiltered.length == 0">Нет результатов</div>
                        <label class="input-container" v-for="station in metroFiltered">
                            <input type="checkbox" name="metro" :value="station" v-model="metroSelected">
                            <span class="input-container__label">
                                <span class="metro" :style="{ backgroundColor: station.color }"></span>
                                <span>{{station.station}}</span>
                            </span>
                        </label>
                    </div>
                </div>
            </div>
            <div class="list-dropdown__bg"></div>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash';
    import metro from '../data/metro';

    export default {
        props: ['value'],
        data() {
            return {
                metro,
                metroSelected: this.value,
                metroSearch: "",
                isOpen: false
            }
        },
        methods: {
            toggle(e) {
                this.isOpen = !this.isOpen;
                const documentClickHandler = (e) => {
                    if (!e.target.closest('.list-dropdown') | e.target.closest('.list-dropdown') != this.$el) {
                        this.isOpen = false;
                        document.removeEventListener('click', documentClickHandler);
                    }
                }
                document.addEventListener('click', documentClickHandler);
            }
        },
        computed: {
            metroFiltered() {
                return _.orderBy(this.metro, ['branch', 'order', 'station'])
                    .filter((item) => item.station.toLowerCase()
                        .indexOf(this.metroSearch.toLowerCase()) != -1);
            }
        },
        watch: {
            metroSelected() {
                this.$emit("input", this.metroSelected);
            }
        }
    }
</script>